<div class="validator-message" [hidden]="!errorMessage">{{errorMessage}}</div>